module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mres1-2c412cda791a11354111f63461d42bf6.jpg";